
import { AnimatePresence, motion } from "framer-motion";
import { Welcome } from "./Welcome";
import MessageList from "@/components/MessageList";
import { Message } from "@/types/chat";

interface ChatMessageAreaProps {
  messages: Message[];
  isTransitioning: boolean;
  fadingIn: boolean;
}

/**
 * Handles the display of messages or welcome screen
 * Includes animation transitions between states
 */
export const ChatMessageArea = ({
  messages,
  isTransitioning,
  fadingIn,
}: ChatMessageAreaProps) => {
  return (
    <AnimatePresence mode="wait">
      {messages.length === 0 ? (
        <motion.div
          key="welcome"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="h-full flex items-center justify-center"
        >
          <Welcome />
        </motion.div>
      ) : (
        <motion.div
          key="messages"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className={`h-full overflow-y-auto pt-4 ${
            fadingIn
              ? "opacity-0 transition-opacity duration-300"
              : "opacity-100 transition-opacity duration-300"
          }`}
        >
          <div className="pb-20">
            <MessageList messages={messages} isTransitioning={isTransitioning} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
